import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import BeginningBalance from "../../../containers/modules/accounting/beginning-balance";

export default function BeginningBalanceRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="beginning-balance"
      index
      element={
        <AccessControl
          name={"Beginning Balance List"}
          auth={authUser}
          component={() => <BeginningBalance />}
        />
      }
    />
  );
}
